<template>
  <div class="footer-container">
    <div class="row">
      <div class="footer-left">
        <ul>
          <li><a>[Contact]:Micheal Wang</a></li>
          <li><a>
            <span style="display:block;">[Tel.1]:0371-86153190</span>
            <span style="display:block;">[Tel.2]:0371-63737206</span></a></li>
          <li><a>[Fax]:0371-63737012</a></li>
        </ul>
      </div>
      <div class="footer-left">
        <ul>
          <li><a>[E-mail]:<br>18618429755@163.com</a></li>
          <li><a>[Address]:<br>Room 1605-16F, 32 Weisi Road East, Jinshui District, Zhengzhou City, Henan Province, P. R.China</a></li>
        </ul>
      </div>
      <div class="footer-right">
        <img src="../../public/img/QRCode.png" style="height:150px;">
      </div>
    </div>
    <div class="row">
      <div class="footer-lower">
        <a href="http://www.beian.miit.gov.cn"><span class="text-left">豫ICP备18005639号</span></a>
        <span class="text-right">DeXin Chemical © Copyright 2019</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer-en'
}
</script>

<style lang="scss">
  .footer-container {
    background-color: #f7f7f7;
    margin: 0 auto;
    max-width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;

    .row {
      margin-left: 15px;
      margin-right: 15px;
      overflow: hidden;

      .footer-left {
        float: left;
        width: 20%;
        text-align: left;
        @media(max-width: 768px) {
          width: 40%;
        }

        ul {
          padding: 0;

          li {
            list-style-type: none;
            a {
              font-size: 14px;
              line-height: 32px;
            }
          }
        }
      }

      .footer-right {
        margin-right: 10%;
        @media(min-width: 768px) {
          float: right;
        }
      }

      .footer-lower {
        margin-top: 40px;
        border-top: 1px solid #cccccc;
        padding-top: 32px;
        font-size: 14px;
        line-height: 24px;
        .text-left {
          color: #888;
          float: left;
        }
        .text-right {
          color: #888;
          float: right;
        }
      }
    }
  }
</style>
